<template>
  <div>
    <b-overlay :show="show" rounded="sm">
      <b-card>
        <b-row>
          <b-col sm="12">
            <div class="d-flex flex-wrap align-content-sm-center">
              <div class="p-2 flex-grow-1">
                <h5 class="text-logisty-profile-heading">เรตติ้ง</h5>
              </div>
              <div class="p-2">
                <b-button
                  v-if="$cookies.get('companyId') !== revieweeId"
                  class="float-right"
                  variant="primary"
                  :to="{name: 'สร้างรีวิว', params: {companyUrl:$route.params.companyUrl}}"
                >เขียนรีวิว</b-button>
              </div>
              <div class="p-2">
                <b-form-select
                  class="float-right"
                  v-model="sortBy"
                  :options="sortOption"
                  @input="doSort"
                ></b-form-select>
              </div>
            </div>
          </b-col>
        </b-row>
        <div v-if="ratingList.length > 0" class="p-2">
          <b-row v-for="(item, index) in ratingListPaginate" v-bind:key="index">
            <!-- <b-col xs="12" sm="12" md="3" class="text-center" align-self="center">
              <div class="d-none d-sm-block">
                <b-img
                  v-if="!item.logo"
                  src="/img/icon/No_image.png"
                  width="100"
                  height="100"
                  fluid
                />
                <b-img
                  v-else
                  :src="'data:image/jpeg;base64,'+item.logo.imgBase64"
                  width="100"
                  height="100"
                  fluid
                />
              </div>
              <div class="d-block d-sm-none profile-logo">
                <b-img v-if="!item.logo" src="/img/icon/No_image.png" />
                <b-img v-else :src="'data:image/jpeg;base64,'+item.logo.imgBase64" />
              </div>
              <br />
              <span class="rating-reviewer-name">{{ item.reviewerCompany.name }}</span>
            </b-col> -->
            <b-col xs="12" sm="12" md="12">
              <div class="d-none d-sm-block">
                <star-rating :disabled="true" :value="item.rating"></star-rating>
              </div>
              <div class="d-block d-sm-none text-center">
                <star-rating :disabled="true" :value="item.rating"></star-rating>
              </div>
              <div class="rating-comment">{{ item.content }}</div>
              <br />
              <span class="text-muted">เมื่อ {{ $moment(item.createdAt).format('LLL') }}</span>
            </b-col>
            <b-col sm="12">
              <hr class="divider" />
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col>
              <b-pagination
                class="flex-wrap"
                v-model="currentPage"
                :total-rows="ratingList.length"
                :per-page="perPage"
                first-text="หน้าแรก"
                prev-text="ก่อนหน้า"
                next-text="ถัดไป"
                last-text="หน้าสุดท้าย"
                @input="updateRatingPage"
              ></b-pagination>
            </b-col>
          </b-row>
        </div>
        <div v-else>
          <b-row>
            <b-col>
              <p>ยังไม่มีรีวิว</p>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>
  </div>
</template>

<style>
.rating-comment {
  font-size: 1.2em;
}
.rating-reviewer-name {
  font-size: 1.2em;
}
</style>

<script>
import Profile from '../../services/http/Profile'
import StarRating from '../../components/StarRating'

export default {
  components: {
    StarRating
  },
  props: {
    revieweeId: {
      default: null,
      required: true
    }
  },
  data () {
    return {
      sortBy: 'desc',
      sortOption: [
        { value: 'desc', text: 'เรียงจากใหม่-เก่า' },
        { value: 'asc', text: 'เรียงจากเก่า-ใหม่' }
      ],
      show: false,
      ratingList: [],
      ratingListPaginate: [],
      currentPage: 1,
      perPage: 5
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      this.show = true
      var profile = new Profile()
      try {
        let data = {
          all: true,
          revieweeId: this.revieweeId
        }

        // get rating list
        let ratingList = await profile.getListRatingReview(data)
        if (ratingList.code === 1) {
          this.ratingList = ratingList.data

          // sort by desc
          const sortDateDesc = (a, b) => this.$moment(b.createdAt) - this.$moment(a.createdAt)
          this.ratingList = ratingList.data.sort(sortDateDesc)

          // slice data to paginate
          let start = (this.currentPage - 1) * this.perPage
          let end = start + this.perPage
          this.ratingListPaginate = this.ratingList.slice(start, end)
        } else {
          // unexpected error from server
          await this.$bvModal.msgBoxOk('โปรดติดต่อผู้ดูแลระบบ', this.$getConst('okModalClass'))
        }
      } catch (error) {
        // unexpected error from vue
        await this.$bvModal.msgBoxOk('โปรดติดต่อผู้ดูแลระบบ', this.$getConst('okModalClass'))
      }
      this.show = false
    },
    doSort () {
      const sortDateDesc = (a, b) => this.$moment(b.createdAt) - this.$moment(a.createdAt)
      const sortDateAsc = (a, b) => this.$moment(a.createdAt) - this.$moment(b.createdAt)

      if (this.sortBy === 'desc') {
        this.ratingList.sort(sortDateDesc)
      } else {
        this.ratingList.sort(sortDateAsc)
      }
      this.updateRatingPage()
    },
    updateRatingPage () {
      let start = (this.currentPage - 1) * this.perPage
      let end = start + this.perPage
      this.ratingListPaginate = this.ratingList.slice(start, end)
    }
  }
}
</script>
